<template>
  <div>
    <!-- <router-link to="/posts/new-post" class="btn-basic float-right"
      >New Post</router-link
    > -->
    <div class="card card-body p-0" style="border-radius: 10px">
      <post-table :posts="posts" :totalPages="totalPages" :page="page" @setPage="setPage" :setSkeletonLoader="displayLoader"></post-table>
    </div>
  </div>
</template>

<script>
  import helpers from "@/helpers.js";
  import PostTable from "./post_table";
  import VueSkeletonLoader from 'skeleton-loader-vue';
  export default {
    components: {
      PostTable,VueSkeletonLoader,
    },

    data: function () {
      return {
        page: 0,
        fullPage: "",
        displayLoader: true,
      };
    },

    computed: {
      posts: function () {
        return this.$store.getters["posts/posts"];
      },
      totalPages: function () {
        return this.$store.getters["posts/totalPages"];
      },
    },

    created: function () {
      this.page = helpers.getPageQuery();
    },

    watch: {
      page: function (val) {
        // let loader = this.$loading.show({
        //   loader: "dots",
        //   container: this.fullPage ? null : this.$refs.formContainer,
        // });
        this.setSkeletonLoader(true);
        this.$store.dispatch("posts/getUnpublishedPosts", val)
        .then(()=>{
          setTimeout(() => {
            this.setSkeletonLoader(false);
          }, 400);
        });
      },
    },

    methods: {
      setPage(page) {
        this.page = page;
        this.$router.push("unpublished?page=" + page);
      },
      setSkeletonLoader(val){
        this.displayLoader = val;
        this.$forceUpdate();
      },
    },
  };
</script>
<style>
  .custom {
    position: absolute;
    z-index: 999;
    top: 246px;
    left: 40%;
    opacity: 0.5;
  }
</style>